export default __webpack_public_path__ + "static/media/Kriti and Kai_Johnsons Locust Hall Farm_AS Nagpal_7.17340c0c.JPG";